module.exports = __webpack_public_path__ + "img/niño65.54f3b47d.jpg";